import { Component, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { StudentBookService as DesktopStudentBookService } from 'modules/desktop/services/student-book.service';
declare var $: any;

@Component({
    selector: 'app-asset-error-modal',
    styleUrls: ['./asset-error-modal.style.scss'],
    templateUrl: './asset-error-modal.template.html'
})
export class AssetErrorModal implements AfterViewInit {

    isOnline = false;
    isShown = false;

    constructor(
        private chRef: ChangeDetectorRef,
        private desktopStudentBookService: DesktopStudentBookService,
    ) { }

    ngAfterViewInit(): void {

        let that = this;

        $('#assetErrorModal').on('hide.bs.modal', function (e) {
            let modal: any = document.querySelector('#assetErrorModal');
            modal.removeAttribute("mode");
            modal.removeAttribute("bookcode");
            that.isOnline = false;
            that.isShown = false;
        })

        $('#assetErrorModal').on('shown.bs.modal', function (e) {
            let mode = document.querySelector('#assetErrorModal').getAttribute("mode");
            if (mode == 'online') {
                that.isOnline = true;
            }
            that.isShown = true;
        })

    }

}